import { jsx as _jsx } from "react/jsx-runtime";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
export var FAIRE_BELONGING_EMPLOYEES = function(strictLocalize) {
    return [
        {
            text: strictLocalize({
                id: "zi3b9l",
                defaultMessage: [
                    {
                        type: 0,
                        value: "\u201CI\u2019ve been overjoyed by how Faire celebrates diversity. To empower our entrepreneurs, we need to understand how their diverse experiences play a role in their entrepreneurial journeys. I had the honor of hosting a company-wide panel with some of our LGBTQ+ customers, where they shared how their LGBTQ+ experiences inform the way they run their businesses and how Faire can help along the way. Faire consistently strives to amplify the voices of both our customers and employees.\u201D"
                    }
                ]
            }),
            name: "Ben Dreier",
            info: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                id: "IqS4C5",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Director of Product"
                    }
                ]
            }),
            imageUrl: "https://cdn.faire.com/fastly/ae983ade938c69d4688ad584788fd62bceafd06ffe5c788ae2266bda7d7e5773.png"
        }
    ];
};
